<template>
    <div class="section-box videoDeatil" v-loading="loading">
        <div class="title-box">
            <div class="detail-title">大咖面对面详情</div>
            <div class="save-box">
                <el-button type="primary" class="save" @click="save()">保存</el-button>
                <el-button type="danger" class="save" v-if="pkid != -1" @click="del()">删除</el-button>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="150px" class="name">
            <el-form-item label="大咖面对面名称" prop="name">
                <el-input v-model.trim="form.name" class="nameInput"></el-input>
            </el-form-item>
        </el-form>
        <div v-for="(item, index) in list" :key="index">
            <el-row class="commonTitle" :gutter="20">
                <el-col :span="6" :offset="0">第{{ index + 1 }}章</el-col>
                <el-col :span="1" :offset="17" class="deleteCls">
                    <span @click="delOne(index)">删除</span></el-col>
            </el-row>
            <el-row>
                <el-col :span="2" class="redIcon">上传封面</el-col>
                <el-col :span="10">
                    <div class="uploadBox">
                        <div class="upload1">
                            <div @click="maskIndex = index">
                                <el-upload class="show" :class="{ hide: item.hideUploadCover }" :action="url"
                                    list-type="picture-card" :limit="1" :file-list="item.fileListCover"
                                    :on-change="dealImgChangeCover"
                                    :on-remove="(file, fileList) => {handleDealImgRemoveCover(file, fileList, index)}"
                                    :on-success="handleAvatarSuccessCover" :on-preview="handlePictureCardPreview"
                                    :before-upload="uploadPreview" accept=".jpg, .jpeg, .png">
                                    <i class="el-icon-plus"></i>
                                </el-upload>

                                <!-- <span class="tips">300*150,格式：gif/png/jpeg</span> -->
                                <span class="tips">格式：gif/png/jpeg</span>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2" class="redIcon">上传视频</el-col>
                <el-col :span="10">
                    <div class="uploadBox">
                        <div class="upload1">
                            <div @click="videoIndex = index">
                                <!-- <el-upload class="avatar-uploader el-upload--text" :action="videoUrl"
                                    :show-file-list="false" :on-success="handleVideoSuccess" list-type="picture-card"
                                    accept=".mp4" :before-upload="beforeUploadVideo" :on-progress="uploadVideoProcess">
                                    <video v-if="item.Video != '' && item.videoFlag == false" :src="item.Video"
                                        class="avatar" controls="controls">
                                        您的浏览器不支持视频播放
                                    </video>
                                    <i v-else-if="item.Video == '' && item.videoFlag == false"
                                        class="el-icon-plus avatar-uploader-icon"></i>
                                    <el-progress v-if="item.videoFlag == true" type="circle"
                                        :percentage="item.videoUploadPercent" style="margin-top: 10px"></el-progress>
                                </el-upload> -->
                                <el-upload class="avatar-uploader el-upload--text" action :http-request="Upload"
                                    :before-upload="beforeAvatarUpload" :on-preview="handlePreview"
                                    :before-remove="beforeRemove" :on-remove="handleRemove" :on-success="handleSuccess"
                                    drag :show-file-list="false" accept=".mp4">
                                    <span class="timeDom" v-if="item.Video != '' && item.videoFlag == false"><img
                                            src="@/assets/video.png" alt="" class="videoIcon2"><b
                                            v-text="resultFormat(item.timeSpan)"></b></span>
                                    <video v-if="item.Video != '' && item.videoFlag == false" :src="item.Video"
                                        class="avatar" controls="controls">
                                        您的浏览器不支持视频播放
                                    </video>
                                    <i v-else-if="item.Video == '' && item.videoFlag == false"
                                        class="el-icon-plus avatar-uploader-icon"></i>
                                    <!-- videoUploadPercent -->
                                    <el-progress v-if="item.videoFlag == true" type="circle"
                                        :percentage="item.videoUploadPercent" style="margin-top: 10px"></el-progress>
                                </el-upload>

                                <el-button size="mini" type="danger" v-if="item.Video" @click="
                    item.Video = '';
                    item.videoUploadId = '';
                  ">
                                    删除文件重新上传
                                </el-button>
                                <span class="tips">仅支持MP4格式，大小不超过10G</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col :span="2" class="redIcon">视频标题</el-col>
                <el-col :span="10">
                    <el-input size="medium" placeholder="请输入章节名称" maxlength="200" class="chapterName"
                        v-model.trim="item.name" style="width: 70%"></el-input>
                </el-col>
                <el-col :span="2" class="redIcon">视频简介</el-col>
                <el-col :span="10">
                    <el-input type="textarea" placeholder="请输入内容" maxlength="1000" show-word-limit rows="4"
                        class="chapterContent" v-model.trim="item.content" style="width: 70%">
                    </el-input>
                </el-col>
            </el-row>
        </div>

        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                    <el-button type="text" @click="addOne">新增</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {
        Decrypt
    } from "@/utils/crypto";
    import {
        client,
        getFileNameUUID
    } from "@/utils/ali-oss"; //前面的ali-js文件内的两个封装函数
    import {
        getActionData
    } from "@/utils/store";
    import apiEnv from "@/service/apiEnv.js";
    import {
        addMaster,
        getMasterDetail,
        updateDetail,
        delMaster,
    } from "@/service/masterApi";
    export default {
        components: {},
        data() {
            return {
                actionData: JSON.parse(getActionData()), //功能按钮每个页面必须用
                form: {
                    name: "",
                },
                rules: {
                    name: [{
                            required: true,
                            message: "请输入名称",
                            trigger: "blur",
                        },
                        {
                            min: 1,
                            max: 100,
                            message: "长度在 1 到 100 个字符",
                            trigger: "blur",
                        },
                    ],
                },
                url: apiEnv.uploadURL,
                limitCount: 1,
                list: [],
                maskIndex: null,
                videoUrl: "",
                videoIndex: null,
                pkid: "",
                loading: false,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$refs.ruleForm.resetFields();
                if (vm.$route.query.pkid) {
                    vm.pkid = vm.$route.query.pkid;
                    vm.init();
                } else {
                    vm.pkid = "";
                }
            });
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form));

            let api =
                process.env.NODE_ENV == "development" ?
                "/api1" :
                process.env.VUE_APP_API1;
            this.videoUrl = api + "/api/Upload/UploadNoWaterVideo";

            this.init();
        },
        watch: {},
        methods: {
            resultFormat(values) {
                var value = parseInt(values)
                var h = Math.floor(value / 3600);
                var m = Math.floor((value / 60 % 60));
                var s = Math.floor((value % 60));
                if (h < 1) {
                    h = '00'
                }
                if (m < 9) {
                    m = '0' + m
                }
                if (s < 10) {
                    s = '0' + s
                }
                return h + ':' + m + ':' + s
            },
            //大文件上传
            // 文件超出个数限制时的钩子
            // handleExceed(files, fileList) {

            //   this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
            // },

            // 点击文件列表中已上传的文件时的钩子
            handlePreview(file) {

            },

            // 删除文件之前的钩子
            beforeRemove(file, fileList) {

                // return this.$confirm(`确定移除 ${file.name}？`);
            },

            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {

            },

            // 文件上传成功时的钩子
            handleSuccess(response, file, fileList) {

                // this.fileList = fileList;
            },

            //文件上传前的校验
            beforeAvatarUpload(file) {
                const _this = this
                //file.size返回b单位
                const isLt10M = file.size/1024/1024/1024<10;
                if (
                    [
                        "video/mp4",
                        "video/ogg",
                        "video/flv",
                        "video/avi",
                        "video/wmv",
                        "video/rmvb",
                    ].indexOf(file.type) == -1
                ) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error("上传视频大小不能超过10G哦!");
                    return false;
                }
                // 获取视频时长
                var url = URL.createObjectURL(file);
                var audioElement = new Audio(url);
                var duration;
                audioElement.addEventListener("loadedmetadata", function (_event) {
                    duration = audioElement.duration; //时长为秒，小数，182.36
                    _this.list[_this.videoIndex].timeSpan = parseInt(duration);
                });
                _this.loading = true;
            },
            Upload(file) {
                const config = {
                    region: "oss-cn-zhangjiakou",
                    accessKeyId: "LTAIm1hXML86TVS4",
                    accessKeySecret: "TsgBJS0oD3V0YBkYs6P8XnFVo0GH1O",
                    bucket: "gk-manager",
                };
                const that = this;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = getFileNameUUID() + "." + fileFormat;
                    client(config)
                        .multipartUpload(`video/${fileName}`, file.file, {
                            progress: function (p) {
                                that.list[that.videoIndex].videoFlag = true;
                                that.list[that.videoIndex].videoUploadPercent = Math.floor(p * 100);
                            }
                        })
                        .then(result => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            // console.log(result.res.requestUrls[0]);
                            var totalUrl = result.res.requestUrls[0];
                            that.list[that.videoIndex].videoFlag = false;
                            that.list[that.videoIndex].videoUploadPercent = 0;
                         
                            that.list[that.videoIndex].videoUploadId = that.getQueryVariable(totalUrl,'uploadId');
                            that.list[that.videoIndex].Video = totalUrl.split("?")[0]
                            that.loading = false;
                        })
                        .catch(err => {
                            that.loading = false;
                            that.$message.error(err)
                        });
                }
                multipartUpload();
            },
            getQueryVariable(url, paraName) {
                var arrObj = url.split("?");
                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            //大文件上传
            del() {
                this.$confirm("是否确定删除整个素材?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        var params = {
                            pkid: this.pkid,
                        };
                        delMaster(params).then((r) => {
                            if (r.Result != 1) {
                                this.$message.error("删除失败");
                                return;
                            }
                            this.$message.success("删除成功");
                            this.resetDeatil();
                            this.$router.push(`/market/videoList`);
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },
            init() {
                const _this = this
                this.pkid = this.$route.query.pkid;
                if (this.pkid == "-1") {
                    this.list = [];
                    this.list.push({
                        name: "",
                        content: "",
                        //s上传
                        hideUploadCover: false,
                        fileListCover: [],
                        dialogImageUrl: "", //封面图
                        DialogsImageUrlCover: "",
                        //e上传
                        //s upload
                        Video: "",
                        videoUploadId: "",
                        videoFlag: false,
                        videoUploadPercent: 0,
                        //e upload
                    });
                } else {
                    var params = {
                        pkid: this.pkid,
                    };
                    getMasterDetail(params).then((r) => {
                        if (r.Result != 1) {
                            this.$message.error("获取详情失败");
                        }
                        _this.list = [];
                        const d = r.Data;
                        const arr = r.Data.mediaDetailVOS;
                        this.form.name = d.name;
                        for (let i = 0; i < arr.length; i++) {
                            var item = arr[i];
                            let objCover = {};
                            objCover.url = item.imgUrl;
                            var temp = [];
                            temp.push(objCover);
                            _this.list.push({
                                name: item.title,
                                content: item.content,
                                hideUploadCover: true,
                                fileListCover: temp,
                                dialogImageUrl: "",
                                DialogsImageUrlCover: item.imgUrl,
                                Video: Decrypt(item.videoUrl),
                                videoUploadId: "",
                                videoFlag: false,
                                videoUploadPercent: 0,
                                pkid: item.pkid,
                                timeSpan:item.timeSpan
                            });
                        }
                    });
                    return;
                }
            },
            resetDeatil() {
                this.list = [];
                this.form.name = "";
                this.pkid = "";
            },
            save() {
                const _this = this;
                this.$refs["ruleForm"].validate((valid) => {
                    if (!valid) {
                        this.$message.error("请填写大咖面对面名称");
                        return;
                    }
                    if (valid) {
                        for (let i = 0; i < _this.list.length; i++) {
                            if (!_this.list[i].DialogsImageUrlCover) {
                                _this.$message.error("封面图请完整上传");
                                return;
                            }
                            if (!_this.list[i].Video) {
                                _this.$message.error("视频请完整上传");
                                return;
                            }
                            if (!_this.list[i].name) {
                                _this.$message.error("章节名称请填写完整");
                                return;
                            }
                            if (!this.list[i].content) {
                                _this.$message.error("内容请输入完整");
                                return;
                            }
                        }

                        if (this.pkid == "-1") {
                            this.add();
                            return;
                        } else {
                            this.edit();
                            return;
                        }
                    }
                });
            },
            //新增
            add() {
                const _this = this;
                this.loading = true;
                var temp = [];
                for (let i = 0; i < _this.list.length; i++) {
                    temp.push({
                        content: _this.list[i].content,
                        imgUrl: _this.list[i].DialogsImageUrlCover,
                        title: _this.list[i].name,
                        videoUrl: _this.list[i].Video,
                        timeSpan: _this.list[i].timeSpan
                    });
                }
                var params = {
                    name: this.form.name,
                    mediaAddDTOList: temp,
                };
                addMaster(params).then((r) => {
                    this.loading = false;
                    if (r.Result != 1) {
                        this.$message.error("保存失败");
                    }
                    this.$message.success("保存成功");
                    this.resetDeatil();
                    this.$router.push(`/market/videoList`);
                });
            },
            edit() {
                const _this = this;
                this.loading = true;
                var temp = [];
                for (let i = 0; i < _this.list.length; i++) {
                    temp.push({
                        content: _this.list[i].content,
                        imgUrl: _this.list[i].DialogsImageUrlCover,
                        title: _this.list[i].name,
                        videoUrl: _this.list[i].Video,
                        pkid: _this.list[i].pkid,
                        timeSpan: _this.list[i].timeSpan
                    });
                }
                var params = {
                    name: this.form.name,
                    mediaUpdateDTOList: temp,
                    pkid: this.pkid,
                };
                updateDetail(params).then((r) => {
                    this.loading = false;
                    if (r.Result != 1) {
                        this.$message.error("编辑失败");
                    }
                    this.$message.success("编辑成功");
                    this.resetDeatil();
                    this.$router.push(`/market/videoList`);
                });
            },
            //s视频上传

            // beforeUploadVideo(file) {
            //     const isLt10M = file.size / 1024 / 1024 < 10;
            //     if (
            //         [
            //             "video/mp4",
            //             "video/ogg",
            //             "video/flv",
            //             "video/avi",
            //             "video/wmv",
            //             "video/rmvb",
            //         ].indexOf(file.type) == -1
            //     ) {
            //         this.$message.error("请上传正确的视频格式");
            //         return false;
            //     }
            //     if (!isLt10M) {
            //         this.$message.error("上传视频大小不能超过10G哦!");
            //         return false;
            //     }
            // },

            // uploadVideoProcess(event, file, fileList) {
            //     this.list[this.videoIndex].videoFlag = true;
            //     this.list[this.videoIndex].videoUploadPercent = Number(
            //         file.percentage.toFixed(0)
            //     );
            // },
            // handleVideoSuccess(res, file) {
            //     //获取上传图片地址
            //     this.list[this.videoIndex].videoFlag = false;
            //     this.list[this.videoIndex].videoUploadPercent = 0;
            //     if (res.Result == 1) {
            //         this.list[this.videoIndex].videoUploadId = res.Data[0].FileId;
            //         this.list[this.videoIndex].Video = res.Data[0].FileUrl;
            //     } else {
            //         this.$message.error("视频上传失败，请重新上传！");
            //     }
            // },
            //e视频上传

            //s封面上传
            uploadPreview(file) {
                let _this = this;
                const isSize = new Promise(function (resolve, reject) {
                    let width = 300; // 限制图片尺寸为654X270
                    let height = 150;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        // let valid = img.width === width && img.height === height;
                        let valid = true
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                }).then(
                    () => {
                        return file;
                    },
                    () => {
                        // _this.$message.error("图片尺寸限制为300 x 150");
                        return Promise.reject();
                    }
                );
                return isSize;
            },
            dealImgChangeCover(file, fileList) {
                this.list[this.maskIndex].hideUploadCover =
                    fileList.length >= this.limitCount;
            },
            //删除上传文件Cover
            handleDealImgRemoveCover(file, fileList, fileIndex) {
                this.maskIndex = fileIndex
                this.list[this.maskIndex].hideUploadCover =
                    fileList.length >= this.limitCount;
                this.list[this.maskIndex].fileListCover = fileList;
                this.list[this.maskIndex].DialogsImageUrlCover = "";
            },
            //上传成功Cover
            handleAvatarSuccessCover(res, file, fileList) {
                if (res.Result != 1) {
                    this.list[this.maskIndex].fileListCover = [];
                    return this.$message.error(res.Message);
                }
                fileList[0].url = res.Data[0].imgUrl;
                this.list[this.maskIndex].fileListCover = fileList;
                this.list[this.maskIndex].DialogsImageUrlCover = res.Data[0].imgUrl;
            },
            //点击图片查看
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            //e封面上传
            addOne() {
                this.list.push({
                    name: "",
                    content: "",
                    //s上传
                    hideUploadCover: false,
                    fileListCover: [],
                    dialogImageUrl: "", //封面图
                    DialogsImageUrlCover: "",
                    //e上传
                    //s upload
                    Video: "",
                    videoUploadId: "",
                    videoFlag: false,
                    videoUploadPercent: 0,
                    //e upload
                });
            },
            delOne(index) {
                if (this.list.length <= 1) {
                    this.$message.error("不能少于一个章节");
                    return;
                }
                this.list.splice(index, 1);
                // debugger
            },
        },
    };
</script>
<style lang="scss">
    .title-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: bottom;

        .detail-title {
            padding: 0 20px;
            height: 40px;
            border-top: 1px solid #e5e5e5;
            border-right: 1px solid #e5e5e5;
            border-left: 1px solid #e5e5e5;
            text-align: center;
            line-height: 40px;
            color: #409EFF;
            font-size: 14px;
        }

        .save-box {
            display: flex;
            width: calc(100% - 140px);
            flex-direction: row;
            justify-content: flex-end;
            border-bottom: 1px solid #e5e5e5;
            align-items: flex-end;
            height: 40px;
            .publish {
                width: 100px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                margin-bottom: 12px;
            }

            .save {
                width: 100px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                margin-bottom: 12px;
            }
        }
    }

    .videoDeatil {
        .name {
            margin-top: 28px;

            .nameInput {
                width: 800px;
            }
        }
    }

    .commonTitle {
        height: 48px;
        background-color: #f9f9f9;
        border: solid 1px #e5e5e5;
        font-size: 16px;
        color: #111111;
        line-height: 48px;
        margin: 32px 0 19px;
        padding-left: 23px;

        .deleteCls {
            color: rgb(245, 108, 108);
            cursor: pointer;
        }
    }

    // .item {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: flex-start;
    //     align-items: flex-start;

    //     .uploadBox {
    //         display: flex;
    //         flex-direction: row;
    //         align-items: center;
    //         justify-items: flex-start;

    //         .upload1 {
    //             display: flex;
    //             flex-direction: row;
    //             justify-content: flex-start;
    //             width: 300px;
    //         }
    //     }


    // }

    .tips {
        margin-top: 15px;
        font-size: 14px;
        color: rgb(195, 195, 195);
        display: block;
    }

    // .chapterName {
    //     width: 600px;
    // }

    // .chapterContent {
    //     width: 600px;
    //     margin-top: 15px;
    // }

    .hide .el-upload--picture-card {
        display: none;
    }

    .bg-purple-dark {
        background: #e5e9f2;
        text-align: center;
        margin: 20px 0 0 0;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .avatar {
        width: 148px;
        height: 148px;
    }

    .redIcon::before {
        content: "* ";
        color: #F56C6C;
        margin-right: 4px;
    }

    .el-upload-list__item {
        transition: none !important;
    }

    .avatar-uploader-icon {
        margin-top: 67px;
    }
    .avatar,
    .el-upload-dragger {
        width: 148px;
        height: 148px;
    }
    .timeDom {
        display: block;
        position: absolute;
        padding: 2px;
        color: #fff;
        top: 0;
        right: 0;
        z-index: 999;
        background: #000;

        .videoIcon2 {
            height: 18px;
            width: auto;
            vertical-align: text-bottom;
            margin-left: 5px;
        }
    }
</style>